import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const EntityContext = createContext();

export function EntityProvider({ children }) {
  const [entities, setEntities] = useState([]);
  const [activeEntityId, setActiveEntityId] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadEntities = useCallback(async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return;
      const res = await axios.get(`${API}/api/entities`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setEntities(res.data);
      // Set default entity from localStorage or first entity
      // 'all' adalah special value untuk Konsolidasi mode (lintas semua entity)
      const saved = localStorage.getItem('activeEntityId');
      if (saved === 'all' || (saved && res.data.find(e => e.id === saved))) {
        setActiveEntityId(saved);
      } else if (res.data.length > 0) {
        setActiveEntityId(res.data[0].id);
        localStorage.setItem('activeEntityId', res.data[0].id);
      }
    } catch (err) {
      console.error('Failed to load entities:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadEntities();
  }, [loadEntities]);

  const switchEntity = (entityId) => {
    setActiveEntityId(entityId);
    localStorage.setItem('activeEntityId', entityId);
  };

  const activeEntity = entities.find(e => e.id === activeEntityId) || null;

  return (
    <EntityContext.Provider value={{
      entities, activeEntityId, activeEntity, switchEntity, loading, reload: loadEntities
    }}>
      {children}
    </EntityContext.Provider>
  );
}

export function useEntity() {
  return useContext(EntityContext);
}
